module.exports = __webpack_public_path__ + "img/0.405d07eb.jpeg";